/**
 * Main JS file for project.
 */
 /* global Ractive, moment, google */
'use strict';

// Dependencies
import utils from './utils.js';
import mapStyles from './map-styles.js';
import tap from 'ractive-events-tap/dist/ractive-events-tap.es.js';
import request from 'superagent';
import _ from 'underscore';
import wherewolf from 'wherewolf';

// Setup
const u = utils({ pym: true });
Ractive.events.tap = tap;
moment.tz.setDefault('America/New_York');
const maps = {};
const geocoder = new google.maps.Geocoder();

// Get data to start
loadData((error, meetings, districts) => {
  if (error) {
    console.error('Error loading data: ' + error);
  }

  // Load up districts
  wherewolf.add('district', districts);

  // Template
  const r = new Ractive({
    el: '.main-content',
    template: document.getElementById('main-template').innerHTML,
    partials: {
      //group: document.getElementById('group-template').innerHTML,
    },
    decorators: {
      map: mapDecorator
    },
    data: {
      meetings: meetings,
      hasGeolocate: u.hasGeolocate(),
      f: {
        extractDomain: u.extractDomain
      }
    }
  });
  // Remove loading
  document.getElementsByClassName('main-content')[0].classList.remove('is-loading');

  // React to search
  r.observe('searchDistrict', (n) => {
    if (!n) {
      return;
    }
    // Hackish way to get district name
    var districtName;

    r.set('meetingsFilter', _.pluck(_.filter(meetings, (m) => {
      if (m.district === n.district || m.district === n.state) {
        districtName = m.district.length === 4 ? m.districtNameLong : districtName;
        return true;
      }
    }), 'bioguideId'));

    r.set('message', districtName);
  });

  // Search
  r.on('searchAddress', (e) => {
    if (e && e.original) {
      e.original.preventDefault();
    }
    r.set('inputError', null);
    r.set('message', 'Searching...');

    if (r.get('address')) {
      geocode(r.get('address'), (error, results) => {
        if (error) {
          r.set('inputError', error);
          if (results.formatted) {
            r.set('address', results.formatted);
          }
        }
        else {
          r.set({
            searchDistrict: results.district,
            searchState: results.state,
            searchCoords: results.coords,
            address: results.formatted
          });
        }
      });
    }
  });

  // Geolocate
  r.on('geolocate', (e) => {
    if (e && e.original) {
      e.original.preventDefault();
    }
    r.set('address', null);
    r.set('inputError', null);
    r.set('message', 'Locating...');

    u.geolocate((error, coords) => {
      // Search districts
      const found = wherewolf.find(coords);

      // Did we find
      if (found && found.district) {
        r.set({
          searchDistrict: found.district,
          searchState: found.state,
          address: 'Current location',
          searchCoords: coords
        });
      }
      else {
        r.set('inputError', error || 'Your location is not in the NYC metro area.');
        r.set('address', 'Current location');
      }
    });
  });
});

// Non template events
document.getElementsByClassName('embed-link')[0].addEventListener('click', (e) => {
  e.preventDefault();
  document.getElementsByClassName('embed-code')[0].classList.toggle('active');
});

// Add body class if embed
if (u.isEmbedded()) {
  document.body.className = document.body.className ? document.body.className += ' embedded' : 'embedded';
}

// Map decorator
function mapDecorator(node, meeting, coordId) {
  const coords = meeting.meetingCoordinates[coordId].split(',').map(parseFloat);
  const id = meeting.bioguideId + '-' + coordId;
  const point = { lat: coords[0], lng: coords[1] };
  const mapIcon = {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 8,
    fillColor: '#21A4C5',
    fillOpacity: 0.9,
    strokeColor: '#FFFFFF',
    strokeWeight: 2
  };
  const defaultZoom = 15;

  // Make map
  if (!maps[id] || !maps[id].map) {
    maps[id] = maps[id] || {};
    maps[id].map = new google.maps.Map(node, {
      zoom: defaultZoom,
      center: point,
      scrollwheel: false,
      styles: mapStyles,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL
      },
      mapTypeControl: false,
      streetViewControl: false,
      draggable: false
    });

    maps[id].marker = new google.maps.Marker({
      position: point,
      icon: mapIcon,
      map: maps[id].map
    });

    // When clicking, enable
    maps[id].enableDrag = () => {
      maps[id].map.setOptions({ draggable: true });
    };
    maps[id].enableDragListener = node.addEventListener('click', maps[id].enableDrag);

    // Handle resize
    maps[id].resize = _.throttle(() => {
      var center = maps[id].map.getCenter();
      google.maps.event.trigger(maps[id].map, 'resize');
      maps[id].map.setCenter(center);
    }, 300);
    maps[id].resizeListener = google.maps.event.addDomListener(window, 'resize', maps[id].resize);
  }

  // Resize
  google.maps.event.trigger(maps[id].map, 'resize');

  return {
    update: function() {
      // Reset map
      maps[id].marker.setMap(null);
      maps[id].marker = new google.maps.Marker({
        position: point,
        icon: mapIcon,
        map: maps[id].map
      });
      maps[id].map.setCenter(point);
      maps[id].map.setZoom(defaultZoom);
      maps[id].map.setOptions({ draggable: false });
    },

    teardown: function () {
      node.removeEventListener('click', maps[id].enableDrag);
      google.maps.event.removeListener(maps[id].resizeListener);
      delete maps[id];
    }
  };
}

// Geocode address
function geocode(address, done) {
  geocoder.geocode({ address: address }, (results, status) => {
    if (status !== 'OK' || !results || !results.length) {
      console.error(status);
      return done('We could not find that address, please try again.');
    }

    // Search for state
    var state = _.find(results[0].address_components, (a) => {
      return ~a.types.indexOf('administrative_area_level_1');
    });
    state = state ? state.short_name : undefined;

    // Search districts
    const found = wherewolf.find(results[0].geometry.location.toJSON());

    // Did we find
    if (found && found.district) {
      done(null, {
        district: found.district,
        formatted: results[0].formatted_address,
        state: state,
        coords: results[0].geometry.location.toJSON()
      });
    }
    else {
      done('This address is not in the NYC metro area.', {
        formatted: results[0].formatted_address,
      });
    }
  });
}

// Get data
function loadData(done) {
  // Geo data
  request.get('./assets/data/districts-filtered.topo.json').end((error, response) => {
    if (error) {
      return done(error);
    }
    const districts = JSON.parse(response.text);

    // Meeting data
    request.get('./assets/data/meetings.json').end((error, response) => {
      if (error) {
        return done(error);
      }
      done(null, _.map(JSON.parse(response.text), (r) => {
        // Transform data
        r.meetingMoments = r.meetingDates ? _.map(r.meetingDates, (d, di) => {
          if (d && d.toLowerCase() !== 'tbd') {
            const time = r.meetingTimes[di] && r.meetingTimes[di] !== 'tbd' ? r.meetingTimes[di] : '';
            return moment(d + ' ' + time, 'YYYY-MM-DD HH:mm');
          }
        }) : undefined;
        r.meetingMoments = _.filter(r.meetingMoments);

        return r;
      }), districts);
    });
  });
}



// WEBPACK FOOTER //
// ./app/index.js